module.exports = __webpack_public_path__ + "img/EV-ARC-Chevy-Volt-Envision-Solar-solar-car.4cbf9f06.png";